"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ScrollContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 158px;
  padding: 8px 8px 0;
  overflow-y: auto;
  align-items: center;
  gap: 16px;

  & > :last-child {
    margin-bottom: 8px;
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: inherit;
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.grasshopper.descriptionPanel.scroll.idle};
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb:hover {
    opacity: 0.8;
  }
`;
exports.default = exports.ScrollContainer;
